import { TemplateGallery } from "@src/components/templates/TemplateGallery";
const TemplateGalleryPage: React.FunctionComponent = () => {
  return <TemplateGallery data-sentry-element="TemplateGallery" data-sentry-component="TemplateGalleryPage" data-sentry-source-file="index.tsx" />;
};
export default TemplateGalleryPage;